import React from 'react'
import {
    Flex,
    Stack,
    Grid,
    GridItem,
    Box,
    Skeleton,
    Divider,
    useMultiStyleConfig,
} from '@chakra-ui/react'

const CartItemSkeleton = () => {
    return (
        <>
            <Flex
                w="100%"
                alignItems="flex-start"
                gap={{base: 3, lg: 4}}
                paddingY={{base: 'small.base', md: 'small.md', lg: 'medium.lg', xl: 'medium.xl'}}
            >
                {/* Product image */}
                <Skeleton
                    borderRadius="large-1"
                    width={{base: '100px', lg: '200px'}}
                    height={{base: '100px', lg: '200px'}}
                    flexShrink={0}
                />

                {/* Product details */}
                <Flex direction="column" flex={1} gap={{base: 3, lg: 4}}>
                    {/* Informative labels */}
                    <Flex gap={2}>
                        <Skeleton height="20px" width="60px" borderRadius="md" />
                        <Skeleton height="20px" width="80px" borderRadius="md" />
                    </Flex>

                    {/* Product name */}
                    <Skeleton
                        height="20px"
                        width={{base: '180px', lg: '280px'}}
                        borderRadius="md"
                    />

                    {/* Quantity picker + Price row */}
                    <Flex
                        direction={{base: 'column', lg: 'row'}}
                        alignItems={{base: 'flex-start', lg: 'center'}}
                        justifyContent="space-between"
                        gap={{base: 3, lg: 4}}
                    >
                        {/* Quantity picker */}
                        <Skeleton height="40px" width="120px" borderRadius="large" />

                        {/* Price + VAT */}
                        <Flex direction="column" alignItems="flex-start" gap={1}>
                            <Skeleton height="20px" width="80px" borderRadius="md" />
                            <Skeleton height="14px" width="60px" borderRadius="md" />
                        </Flex>
                    </Flex>
                </Flex>
            </Flex>
            <Divider />
        </>
    )
}

const OrderSummarySkeleton = () => {
    return (
        <Flex direction="column" gap={4}>
            {/* Title */}
            <Skeleton height="24px" width="160px" borderRadius="md" />

            {/* Summary rows */}
            {[1].map((i) => (
                <Flex key={i} justifyContent="space-between">
                    <Skeleton height="16px" width="120px" borderRadius="md" />
                    <Skeleton height="16px" width="60px" borderRadius="md" />
                </Flex>
            ))}

            {/* Divider */}
            <Divider />

            {/* Total */}
            <Flex justifyContent="space-between">
                <Skeleton height="20px" width="80px" borderRadius="md" />
                <Skeleton height="20px" width="80px" borderRadius="md" />
            </Flex>

            {/* CTA button */}
            <Skeleton height="48px" width="100%" borderRadius="large" />
        </Flex>
    )
}

const CartSkeleton = () => {
    const style = useMultiStyleConfig('Cart', {})

    return (
        <Flex {...style?.cart?.outerContainer}>
            <Box {...style?.cart?.boxContainer} data-testid="sf-cart-skeleton">
                <Grid {...style?.cart?.containerGrid}>
                    <GridItem>
                        <Flex
                            {...style?.cart?.headerFlex}
                            direction="column"
                            alignItems="flex-start"
                            gap={4}
                        >
                            {/* Cart title */}
                            <Skeleton height="32px" width="120px" borderRadius="md" />

                            {/* Shipping banner */}
                            <Skeleton height="40px" width="100%" borderRadius="md" />
                        </Flex>

                        {/* Cart items */}
                        <CartItemSkeleton />
                        <CartItemSkeleton />
                    </GridItem>

                    <GridItem>
                        <Stack {...style?.cart?.orderSummaryContainer}>
                            <OrderSummarySkeleton />

                            {/* Policies */}
                            <Skeleton height="60px" width="100%" borderRadius="md" />

                            {/* Support text */}
                            <Skeleton height="16px" width="200px" borderRadius="md" />
                        </Stack>
                    </GridItem>
                </Grid>
            </Box>
        </Flex>
    )
}

export default CartSkeleton
